const url = "/api/v1/billing_portal";

export interface BillingPortalCreateResponse {
  url: string;
}

export const billingPortalCreateQuery = () => ({
  url,
  method: "POST",
});
